import { makeStyles } from '@material-ui/core/styles'

export const ReorderWidgetStyles = makeStyles(() => ({
  dndDiv: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
}))
